import { UserApi } from "../../api/Api";
import initModal from "../../modal/Modal";
import Helper from "../../legacy/helper";

let modal = $("#email-modal"),
    form = $("#email-modal__form"),
    badEmailError = $("#email-modal__bad-email-error"),
    emailExistsError = $("#email-modal__email-exists-error"),
    badLastNameError = $("#email-modal__bad-lastname-error"),
    defaultError = $("#email-modal__default-error"),
    emailField = $("#accountEmail"),
    lastNameField = $("#accountLastName");


class EmailModal {

    constructor(socialId, userId, accessToken, ssoLoginCallback, isEmailMissing, isLastNameMissing) {
        this.socialId = socialId;
        this.userId = userId;
        this.accessToken = accessToken;
        this.ssoLoginCallback = ssoLoginCallback;
        this.isEmailMissing = isEmailMissing;
        this.isLastNameMissing = isLastNameMissing;

        // Load and display Modal
        initModal();

        // Display needed additional fields for account creation
        if(isEmailMissing) emailField.removeClass("hide");
        if(isLastNameMissing) lastNameField.removeClass("hide");
        form.submit(this.submit);
    }

    submit = () => {
        // Continue account creation by passing social auth info + user's email and/or user's lastname
        if(!this.checkLastName())
            return;

        if(this.isEmailMissing) {
            this.checkEmail(email => this.ssoLoginCallback(this.socialId, this.userId, this.accessToken, email, lastNameField.val()));
        } else {
            this.ssoLoginCallback(this.socialId, this.userId, this.accessToken, undefined, lastNameField.val());
        }
    };

    checkLastName = () => {
        // Hide previous errors
        badLastNameError.addClass("hide");

        if(this.isLastNameMissing && !lastNameField.val().trim()) {
            badLastNameError.removeClass("hide");
            return false;
        } else {
            return true;
        }
    };

    checkEmail = (cb) => {
        // Hide previous errors
        emailExistsError.addClass("hide");
        defaultError.addClass("hide");
        badEmailError.addClass("hide");
        let email = emailField.val().toLowerCase();

        if(!Helper.patterns().email.exec(email)) {
            badEmailError.removeClass("hide");
            return;
        }

        UserApi.checkEmail(email)
            .then((response) => {
                if(response.alreadyExist) {
                    emailExistsError.removeClass("hide");
                } else {
                    cb(email);
                }
            })
            .fail(() => {
                defaultError.removeClass("hide");
            });
    };

    show() {
        modal.addClass("modal--show");
    }
}

export default EmailModal;



// WEBPACK FOOTER //
// ./js/page/login/EmailModal.js